export default __webpack_public_path__ + "ibm-plex-mono-regular.c708fd4f02694c48059f.woff2";